import { Pipe, PipeTransform } from '@angular/core';
import { AppConfigService } from '../../app-config.service';

@Pipe({
  name: 'desjardinsCurrency',
  standalone: false
})
export class DesjardinsCurrencyPipe implements PipeTransform {
  constructor(private readonly _appConfigService: AppConfigService) {}
  transform(montant: string, forceDecimal?: boolean): string {
    // Converti le resultat en decimal a 2 placement  si le string recu a un numero
    let formattedNumber = this.hasNumbers(montant) ? montant : '---';
    const wholeIntegers = formattedNumber.toString().split('.');
    // Si c'est un chiffre avec une décimale, on fixe à 2 pour ajouter un zéro et ne pas laisser comme 52.2 mais plutot 52.20
    // ou
    // Option pour forcer l'affichage de decimales si voulu (exemple: afficher 2.00 au lieu de 2)
    if (forceDecimal || wholeIntegers.length > 1) {
      formattedNumber = parseFloat(formattedNumber).toFixed(2);
    }

    switch (this._appConfigService.configData.contexteEnvironnement.langue) {
      case 'fr':
        formattedNumber = this.montantFR(formattedNumber);
        break;
      case 'en':
        formattedNumber = this.montantEN(formattedNumber);
        break;
      default:
        formattedNumber = this.montantFR(formattedNumber);
        break;
    }
    return formattedNumber;
  }

  montantFR(formattedNumberFinal: string): string {
    return this.formatInteger(
      formattedNumberFinal,
      this._appConfigService.configData.contexteEnvironnement.langue,
      ',',
      '\u00a0'
    );
  }

  formatInteger(formattedNumberFinal: string, lang: string, separator: string, replaceValue: string): string {
    // Spliter le montant string a la decimal
    const wholeInteger = formattedNumberFinal.toString().split('.');
    // Utiliser regex pour rajouter un espace sur tous les 3 occurences de numero
    wholeInteger[0] = wholeInteger[0].replace(/\B(?=(\d{3})+(?!\d))/g, replaceValue);
    const value = wholeInteger.join(separator);
    const formattedNumberFinalFr = value + '\u00a0$';
    const formattedNumberFinalEn = '$' + value;
    return lang === 'fr' ? formattedNumberFinalFr : formattedNumberFinalEn;
  }

  montantEN(formattedNumberFinal: string): string {
    return this.formatInteger(
      formattedNumberFinal,
      this._appConfigService.configData.contexteEnvironnement.langue,
      '.',
      ','
    );
  }

  hasNumbers(input) {
    return /\d/.test(input);
  }
}
